export const common = {
  header: {
    companyName: 'PT. IIJ Global Solutions Indonesia',
  },
  hero: {
    headline: 'Factory Connectivity Without Downtime',
    subheadline: 'Ensure factory operations continue running, even in remote locations',
    cta: 'Start with One Factory',
  },
  problem: {
    title: 'Common Connectivity Issues in Factories',
    paragraph1: 'Many factories face the following challenges:\n\n1. Internet connections frequently drop or become unstable\n2. Production monitoring is not real-time\n3. Communication with headquarters is hindered\n4. Dependency on a single local provider\n5. Downtime risk that directly impacts business\n\nWhen connectivity stops, operations stop.',
  },
  affinity: {
    title: 'The factory operates, but headquarters cannot communicate with the team',
    paragraph1: 'Production continues on the factory floor. But when connectivity becomes unstable, real-time communication breaks down. Video meetings freeze. Calls drop. Messages fail to send.',
    paragraph2: 'Headquarters cannot reach the factory team when decisions need to be made. Conversations that should take minutes are delayed by hours. Management operates with incomplete information and growing frustration.',
  },
  solution: {
    title: 'Satellite connectivity independent of terrestrial infrastructure',
    subtitle: 'Starlink provides satellite-based connectivity that operates independently of local telecommunications infrastructure, enabling continuous monitoring, control, and communication regardless of location.',
    monitoring: {
      title: 'Continuous Monitoring',
      description: 'Real-time visibility into production systems, equipment status, and operational metrics without interruption.',
    },
    control: {
      title: 'Remote Control',
      description: 'Maintain operational control and system access from headquarters regardless of local network conditions.',
    },
    communication: {
      title: 'Reliable Communication',
      description: 'Enable video meetings and voice communication between factory teams and headquarters without dependency on local infrastructure.',
    },
  },
  risk: {
    title: 'How IIJ reduces operational risk',
    subtitle: 'IIJ designs network architectures that eliminate single points of failure by combining Starlink with existing connections and implementing proper redundancy controls.',
    design: {
      title: 'Network Design',
      paragraph1: 'IIJ engineers design network architectures specifically for manufacturing environments, considering latency requirements, bandwidth needs, and failover scenarios.',
      paragraph2: 'Each implementation is tailored to your operational requirements and existing infrastructure.',
    },
    integration: {
      title: 'Integration & Operation',
      paragraph1: 'Starlink connectivity is integrated with your existing network infrastructure, not replacing it. This creates redundancy and eliminates single points of failure.',
      paragraph2: 'IIJ manages ongoing operation, monitoring, and optimization to ensure continuous reliability.',
    },
    partnership: 'IIJ is an authorized Starlink partner, enabling us to officially provide, deploy, and support Starlink as part of a risk-resilient network architecture.',
  },
  offer: {
    title: 'Start from a single factory',
    description: 'IIJ supports the complete process: network design, implementation, and ongoing operation. Begin with one facility to validate the approach before expanding to additional locations.',
    priority: {
      title: 'Priority Program',
      description: 'This program is designed for manufacturing companies operating remote or overseas factories where connectivity reliability directly impacts operational decision-making.',
    },
  },
  finalCta: {
    title: 'Start with one factory.',
    subtitle: 'Experience a network designed to reduce operational risk.',
    button: 'Request a Consultation',
  },
  footer: {
    companyName: 'PT. IIJ Global Solutions Indonesia',
    partnership: 'Authorized Starlink Partner in Indonesia',
    address: 'Indonesia',
    email: 'info@id.iij.com',
    website: 'https://id.iij.com/en',
  },
};
